// Build-time constant, so the banner is dropped from bundles that don't opt in.
export const IS_DEV_MODE = import.meta.env.VITE_DEV_MODE === "true";

// `html.dev-mode` (index.css) moves page scrolling from the window into
// #root, starting below the banner -- the window's own scrollbar always
// spans the full height, so it would otherwise run up behind the banner.
if (IS_DEV_MODE) document.documentElement.classList.add("dev-mode");

// Brand logo color (Crayons Code indigo), see CustomIcon.main.tsx.
const LOGO_COLOR = "#2F3580";

// Height (h-7 = 28px) must stay in sync with the sidebar's h-7 spacer and
// the 1.75rem offset of `html.dev-mode #root` in index.css.
export function DevModeBanner() {
  if (!IS_DEV_MODE) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] flex h-7 items-center justify-center gap-1.5 text-[10px] font-semibold uppercase tracking-widest text-white"
      style={{ backgroundColor: LOGO_COLOR }}
    >
      <span className="size-1.5 rounded-full bg-white/90" aria-hidden />
      <span>Development Mode</span>
      <span className="size-1.5 rounded-full bg-white/90" aria-hidden />
    </div>
  );
}